var Copy_btn = {
  init: function () {
    $(".copy-btn").click(function (e) {
      var range = document.createRange();
      range.selectNode(document.querySelector(".text-to-copy"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();// to deselect
      $('.copy-btn').html('Texte copié');
      setTimeout(function(){
        $('.copy-btn').html('Copier le texte');
      }, 2000);
    });
  }
};
$(window).load(function () {
  if ($(".copy-btn").length) {
    Copy_btn.init();
  }
});
